import { X } from 'lucide-react';

function formatRemaining(ms) {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');
  return `${mm}:${ss}`;
}

export default function SessionTimeoutModal({ isOpen, remainingMs, onContinue, onLogout }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-lg overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <h3 className="text-lg font-semibold text-brand-navy">Session Timeout Warning</h3>
          <button
            type="button"
            onClick={onContinue}
            className="p-1.5 rounded-full text-gray-400 hover:text-brand-navy hover:bg-gray-100 transition-colors"
            title="Close"
            aria-label="Continue session"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-8 text-center space-y-5">
          <p className="text-base text-gray-600">
            Your session will expire soon due to inactivity.
          </p>

          <div className="text-4xl font-bold text-brand-navy tracking-tight">
            {formatRemaining(remainingMs)}
          </div>

          <p className="text-sm text-gray-500">
            Click <span className="font-semibold text-gray-800">Continue Session</span> to stay logged in.
          </p>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-100 bg-gray-50 flex justify-end gap-3">
          <button
            type="button"
            onClick={onLogout}
            className="px-4 py-2 text-sm font-medium text-brand-navy bg-white border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
          >
            Logout
          </button>
          <button
            type="button"
            onClick={onContinue}
            className="px-4 py-2 text-sm font-medium text-white bg-brand-navy rounded-lg hover:bg-brand-navy/90 transition-colors"
          >
            Continue Session
          </button>
        </div>
      </div>
    </div>
  );
}
